import script from "./ServiceTeam.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceTeam.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceTeam.vue?vue&type=style&index=0&id=ca45b566&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca45b566"]])

export default __exports__